import { Component, OnInit } from '@angular/core';
import { UserService }       from '../user/user.service';

@Component({
  selector: 'et-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(public userService: UserService) { }

  ngOnInit(): void {
  }

}
